import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/file-long.svg'


const _withScopeId = n => (_pushScopeId("data-v-af4b2fd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "inner"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Click to view .pdf ")
const _hoisted_3 = {
  key: 1,
  class: "file-viewer-img",
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  class: "file-viewer-img",
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 4,
  class: "photo-labels"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_v_zoomer = _resolveComponent("v-zoomer")!
  const _component_app_video_player = _resolveComponent("app-video-player")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_AppPDFViewerV2 = _resolveComponent("AppPDFViewerV2")!
  const _component_app_pdf_viewer = _resolveComponent("app-pdf-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.media.type === 'PHOTO')
      ? (_openBlock(), _createBlock(_component_v_zoomer, {
          key: 0,
          style: {"width":"100%","height":"100%"},
          maxScale: 10
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_lazy_image, {
              url: `${_ctx.baseURL}${_ctx.media.fileUrl}/${_ctx.PHOTO_VIEW_TYPE.WLRG}`,
              key: _ctx.media.fileUrl,
              "image-fit-contain": ""
            }, null, 8, ["url"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.media.type === _ctx.MEDIA_TYPES.VIDEO)
      ? (_openBlock(), _createBlock(_component_app_video_player, {
          key: 1,
          url: _ctx.baseURL + _ctx.media.fileUrl,
          pauseVideo: _ctx.pauseVideo,
          onIfVideoPaused: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('ifVideoPaused')))
        }, null, 8, ["url", "pauseVideo"]))
      : _createCommentVNode("", true),
    (_ctx.media.type === _ctx.MEDIA_TYPES.FILES)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["file-viewer", { 'file-viewer--centered': true }])
        }, [
          (_ctx.isPDF)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePdfOpen && _ctx.handlePdfOpen(...args))),
                  class: _normalizeClass(["file-viewer-img", { 'action-disabled': _ctx.pdfLoading }]),
                  src: _imports_0,
                  alt: "",
                  style: {"margin-bottom":"20px"}
                }, null, 2),
                _createVNode(_component_el_button, {
                  loading: _ctx.pdfLoading,
                  disabled: _ctx.pdfLoading,
                  onClick: _ctx.handlePdfOpen,
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"]),
                (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
                  _createVNode(_component_AppPDFViewerV2, {
                    "blob-url": _ctx.pdfToOpen,
                    onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pdfToOpen = undefined))
                  }, null, 8, ["blob-url"])
                ]))
              ]))
            : (_openBlock(), _createElementBlock("img", _hoisted_3))
        ]))
      : _createCommentVNode("", true),
    (_ctx.media.type === _ctx.MEDIA_TYPES.FILES && false)
      ? (_openBlock(), _createBlock(_component_v_zoomer, {
          key: 3,
          style: {"width":"100%","height":"100%"},
          maxScale: _ctx.isPDF ? 10 : 1
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["file-viewer", { 'file-viewer--centered': false }])
            }, [
              (_ctx.isPDF)
                ? (_openBlock(), _createBlock(_component_app_pdf_viewer, {
                    key: 0,
                    "video-url": _ctx.baseURL + _ctx.media.fileUrl
                  }, null, 8, ["video-url"]))
                : (_openBlock(), _createElementBlock("img", _hoisted_4))
            ])
          ]),
          _: 1
        }, 8, ["maxScale"]))
      : _createCommentVNode("", true),
    (_ctx.media.labels.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$localize('app.take.photo.all.labels')) + " ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.media.labels, (label) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "photo-labels__item",
              key: label.id
            }, _toDisplayString(label.name), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}